import { render, staticRenderFns } from "./RTasks.vue?vue&type=template&id=a4f147f8&scoped=true&"
import script from "./RTasks.vue?vue&type=script&lang=js&"
export * from "./RTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f147f8",
  null
  
)

export default component.exports